import React from 'react'
import image1 from '../assets/car1.png'
import image2 from '../assets/car2.png'
import image3 from '../assets/car3.png'
import { icons } from '../utilits/icons'

export default function BotttomStatistic() {
  return (
    <div className='cards'>
      <div className="card-one carCard">
        <div className="top">
          <span>{icons.repeatCircle}</span>
          <h3>64% Recommend</h3>
        </div>
        <img src={image1} alt="" />
        <h2>Mini Cooper</h2>
        <div className="bottom">
          <div className="bottom-left">
            <span>{icons.repeatSquare}</span>
            <span>132k</span>
            <span>{icons.carCardBottom1}</span>
            <span>{icons.carCardBottom2}</span>
          </div>
          <p>$32/h</p>
        </div>
      </div>

      <div className="card-two carCard">
        <div className="top">
          <span>{icons.repeatCircle}</span>
          <h3>74% Recommend</h3>
        </div>
        <img src={image2} alt="" />
        <h2>Porsche 911 Carrera</h2>
        <div className="bottom">
          <div className="bottom-left">
            <span>{icons.repeatSquare}</span>
            <span>130k</span>
            <span>{icons.carCardBottom1}</span>
            <span>{icons.carCardBottom2}</span>
          </div>
          <p>$28/h</p>
        </div>
      </div>

      <div className="card-three carCard">
        <div className="top">
          <span>{icons.repeatCircle}</span>
          <h3>54% Recommend</h3>
        </div>
        <img src={image3} alt="" />
        <h2>Porsche Carrera</h2>
        <div className="bottom">
          <div className="bottom-left">
            <span>{icons.repeatSquare}</span>
            <span>120k</span>
            <span>{icons.carCardBottom1}</span>
            <span>{icons.carCardBottom2}</span>
          </div>
          <p>$25/h</p>
        </div>
      </div>

      <div className="card-one carCard">
        <div className="top">
          <span>{icons.repeatCircle}</span>
          <h3>64% Recommend</h3>
        </div>
        <img src={image1} alt="" />
        <h2>Mini Cooper</h2>
        <div className="bottom">
          <div className="bottom-left">
            <span>{icons.repeatSquare}</span>
            <span>132k</span>
            <span>{icons.carCardBottom1}</span>
            <span>{icons.carCardBottom2}</span>
          </div>
          <p>$32/h</p>
        </div>
      </div>
    </div>
  )
}
